import React from 'react'
import { AgreementProvider } from '../../providers/AgreementProvider'
import { Layout } from './Layout'
import { useProps } from './useProps'

const Component = () => <Layout {...useProps()} />

export const MailSendCompletePage = () => {
  return (
    <AgreementProvider>
      <Component />
    </AgreementProvider>
  )
}
